<br>
<!--pre>{{matrixdata | json}}</pre-->

<div *ngIf="matrixdata.length === 0" class="col-md-4">
   Laddar matrikelkort <img src='../../../assets/ajax-loader.gif' style="padding-left:30px;" />
</div>
<div align="center">
<button (click)="captureScreen()" class="btn border" style="margin-left:20px;">Skapa Pdf</button>
</div>
<br>
<div *ngIf="matrixdata" class="col-md-12">

  <div style="width:1200px;border:1px solid #F0F0F0;padding-top:30px;" class="container" #contentToConvert>

    <div *ngFor="let mdata of matrixdata" style="margin-left:60px;">

      <div style="background-color: #F0F0F0;font-weight:bold;" class="left">Matrikelkort för {{mdata.givenName}} {{mdata.familyName}} ({{mdata.id}})  <span class="pull-right">{{timestamp | date:'yyyy-MM-dd HH:mm:ss'}}</span></div>

      <div style="border:1px solid #F0F0F0;width:100%;"></div>
      <div class="row" style="margin-left:20px;">
        <div style="width:67%;">

          <div class="row">
            <div style="width:50%;text-decoration: underline;">Privata uppgifter</div>
            <div style="width:50%;text-decoration: underline;">Medlemsuppgifter</div>
          </div>

          <div class="row">
            <div style="width:25%;">Förnamn</div>
            <div style="width:25%;">{{mdata.givenName}}</div>
            <div style="width:25%;">Medlemsnummer</div>
            <div style="width:25%;">{{mdata.id}}</div>
          </div>

          <div class="row">
            <div style="width:25%;">Övriga Förnamn</div>
            <div style="width:25%;">{{mdata.otherForeNames}}</div>
            <div style="width:25%;">Lokalt medlemsnummer</div>
            <div style="width:25%;">{{mdata.localId}}</div>
          </div>

          <div class="row">
            <div style="width:25%;">Mellannamn</div>
            <div style="width:25%;">{{mdata.middleName}}</div>
            <div style="width:25%;">Skapad</div>
            <div style="width:25%;">{{mdata.createdDate | date: 'yyyy-MM-dd'}}</div>
          </div>

          <div class="row">
            <div style="width:25%;">Efternamn</div>
            <div style="width:25%;">{{mdata.familyName}}</div>
          </div>

          <div class="row">
            <div style="width:25%;">Titel</div>
            <div style="width:25%;">{{mdata.title}}</div>
          </div>

          <div class="row">
            <div style="width:25%;">Född</div>
            <div style="width:25%;">{{mdata.birthday | date: 'yyyy-MM-dd'}}</div>
          </div>

          <div class="row">
            <div style="width:25%;">Fadder</div>
            <div style="width:25%;">{{mdata.mentor}}</div>
          </div>
        </div>
        <div style="width:30%;">
          <mat-card *ngIf="imageToShow !== null" [ngStyle]="{'width': imagewidth + 'px', 'height': imageheight + 50 + 'px', 'font-weight': bold}">
            <img mat-card-image src='{{imageToShow}}' width="imagewidth" style="margin-top:1px;">
            <mat-card-content>
              <p style="text-align:center;text-transform: uppercase;font-size:10px;">{{mdata.givenName}} {{mdata.familyName}}</p>
            </mat-card-content>
          </mat-card>

          <mat-card *ngIf="imageToShow === null" [ngStyle]="{'width': '200px', 'height': '250px', 'font-weight': bold}">
            FOTO SAKNAS
            <mat-card-content>
              <p style="text-align:center;text-transform: uppercase;font-size:10px;">{{mdata.givenName}} {{mdata.familyName}}</p>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
      <div style="width:100%;border:1px solid #F0F0F0;margin-top:10px;"></div>

      <div style="margin-left:20px;">
        <div class="row" style="margin-top:10px;">
          <div style="width:15%;">Telefon hem 1:</div>
          <div style="width:15%;">{{mdata.phone}}</div>
          <div style="width:15%;">E-post 1:</div>
          <div style="width:15%;">{{mdata.email}}</div>
        </div>

        <div class="row">
          <div style="width:15%;">Telefon hem 2:</div>
          <div style="width:15%;">{{mdata.phone2}}</div>
          <div style="width:15%;">E-post 2:</div>
          <div style="width:15%;">{{mdata.email2}}</div>
        </div>

        <div class="row">
          <div style="width:15%;">Telefon arbete:</div>
          <div style="width:15%;">{{mdata.phoneWork}}</div>
          <div style="width:15%;">Hemsida:</div>
          <div style="width:15%;">{{mdata.webSite}}</div>
        </div>

        <div class="row">
          <div style="width:15%;">Telefon mobil:</div>
          <div style="width:15%;">{{mdata.phoneMobile}}</div>
          <div style="width:15%;">SOFT:</div>
          <div *ngIf="mdata.isSubscriber" style="width:15%;">Ja</div>
          <div *ngIf="!mdata.isSubscriber" style="width:15%;">Nej</div>
        </div>

        <div class="row">
          <div style="width:15%;">Telefon fax:</div>
          <div style="width:15%;">{{mdata.fax}}</div>
        </div>

      </div>
      <div style="width:100%;border:1px solid #F0F0F0;margin-top:10px;"></div>

      <div style="margin-left:20px;">
        <div class="row" style="font-weight:bold;margin-top:10px;">
          <div style="width:30%;">Adress hem</div>
          <div style="width:30%;">Adress arbete</div>
          <div style="width:30%;">Adress annan</div>
        </div>

        <div class="row">
          <div style="width:30%;">{{mdata.homeAddress[0]?.careOf}}</div>
          <div style="width:30%;">{{mdata.workAddress[0]?.careOf}}</div>
          <div style="width:30%;">{{mdata.otherAddress[0]?.careOf}}</div>


        </div>


        <div class="row">
          <div style="width:30%;">{{mdata.homeAddress[0]?.street}}</div>
          <div style="width:30%;">{{mdata.workAddress[0]?.street}}</div>
          <div style="width:30%;">{{mdata.otherAddress[0]?.street}}</div>
        </div>

        <div class="row">
          <div style="width:30%;">{{mdata.homeAddress[0]?.zipCode}} {{mdata.homeAddress[0]?.city}}</div>
          <div style="width:30%;">{{mdata.workAddress[0]?.zipCode}} {{mdata.workAddress[0]?.city}}</div>
          <div style="width:30%;">{{mdata.otherAddress[0]?.zipCode}} {{mdata.otherAddress[0]?.city}}</div>

        </div>

        <div class="row">
          <div style="width:30%;">{{mdata.homeAddress[0]?.country}}</div>
          <div style="width:30%;">{{mdata.workAddress[0]?.country}}</div>
          <div style="width:30%;">{{mdata.otherAddress[0]?.country}}</div>

        </div>
      </div>
      <div style="width:100%;border:1px solid #F0F0F0;"></div>

      <div style="margin-left:20px;">
        <div class="row">
          <div style="background-color: #F0F0F0;font-weight:bold;">Medlemskap</div>
        </div>

        <div class="row" style="font-weight:bold;">
          <div style="width:20%;">Institution</div>
          <div style="width:15%;">Från</div>
          <div style="width:25%;">Orsak</div>
          <div style="width:15%;">Till</div>
          <div style="width:25%;">Orsak</div>
        </div>

        <div *ngFor="let ms of mdata.memberships">
          <div class="row">
            <div style="width:20%;">{{ms.shortName}} {{ms.institutionName}}</div>
            <div style="width:15%;">{{ms.startDate | date: 'yyyy-MM-dd'}}</div>
            <div style="width:25%;">{{ms.startDescription}}</div>
            <div *ngIf="ms.endDate.startsWith('9999')" style="width:15%;">--</div>
            <div *ngIf="!ms.endDate.startsWith('9999')" style="width:15%;">{{ms.endDate | date: 'yyyy-MM-dd'}}</div>
            <div style="width:25%;">{{ms.endDescription}}</div>
          </div>
        </div>
      </div>

      <div style="width:100%;border:1px solid #F0F0F0;"></div>

      <div style="margin-left:20px">
        <div class="row">
          <div style="background-color: #F0F0F0;font-weight:bold;">Ämbeten - uppdrag</div>
        </div>

        <div class="row" style="font-weight:bold;">
          <div style="width:15%;">Från</div>
          <div style="width:15%;">Till</div>
          <div style="width:40%;">Uppdrag</div>
          <div style="width:30%;">Institution</div>
        </div>

        <div *ngFor="let o of mdata.offices">
          <div class="row">
            <div style="width:15%;">{{o.fromDate | date: 'yyyy-MM-dd'}}</div>
            <div style="width:15%;">{{o.toDate | date: 'yyyy-MM-dd'}}</div>
            <div style="width:40%;">{{o.officeName}} i {{o.committeeName}}</div>
            <div style="width:30%;">{{o.shortName}}</div>

          </div>
        </div>


      </div>

      <div style="width:100%;border:1px solid #F0F0F0;"></div>

      <div style="margin-left:20px">
          <div class="row">

      <div style="background-color: #F0F0F0;font-weight:bold;">Utmärkelser</div>
</div>

      <div class="row" style="font-weight:bold;">
        <div style="width:15%;">Datum</div>
        <div style="width:40%;">Utmärkelse</div>
        <div style="width:30%;">Institution</div>
      </div>

      <div *ngFor="let s of mdata.signs">
        <div class="row">
          <div style="width:15%;">{{s.date | date: 'yyyy-MM-dd'}}</div>
          <div style="width:40%;">{{s.name}}</div>
          <div style="width:30%;">{{s.shortName}} {{s.institutionName}}</div>
        </div>
      </div>
</div>

<div style="width:100%;border:1px solid #F0F0F0;"></div>
<div style="margin-left:20px">
    <div class="row">
      <div style="background-color: #F0F0F0;font-weight:bold;">Närvaro</div>
</div>

      <div class="row" style="font-weight:bold;">
        <div style="width:5%;">År</div>
        <div style="width:20%;">Institution</div>
        <div style="width:20%;">Ordinarie möte</div>
        <div style="width:20%;">Sommarmöte</div>
        <div style="width:20%;">Övrigt möte</div>
      </div>

      <div *ngFor="let a of mdata.attendance" style="border-bottom:1px solid #F0F0F0;">
        <div class="row">
          <div style="width:5%;">{{a.year}}</div>
          <div style="width:20%;">{{a.institution}}</div>
          <div style="width:20%;">{{a.ordinarieMote}}</div>
          <div style="width:20%;">{{a.sommarMote}}</div>
          <div style="width:20%;">{{a.ovrigtMote}}</div>
        </div>
      </div>
      <div class="row" style="font-weight:bold;margin-top:5px;">
        <div style="font-weight:bold;width:5%;">Totalt</div>
        <div style="width:20%;"></div>
        <div style="width:20%;">{{getSum(mdata.attendance, 'ordinarieMote')}}</div>
        <div style="width:20%;">{{getSum(mdata.attendance, 'sommarMote')}}</div>
        <div style="width:20%;">{{getSum(mdata.attendance, 'ovrigtMote')}}</div>
      </div>
</div>


<div style="width:100%;border:1px solid #F0F0F0;"></div>

      <div *ngIf="mdata.fees?.length > 0">

          <div style="margin-left:20px">
              <div class="row">

        <div style="background-color: #F0F0F0;font-weight:bold;">Medlemsavgifter</div>
</div>
        <div class="row" style="font-weight:bold;">
          <div style="width:5%;">År</div>
          <div style="width:10%;">Institution</div>
          <div style="width:10%;">Betalt totalt</div>
          <div style="width:10%;">Årsavgift</div>
          <div style="width: 10%">Saldo</div>
          <div style="width:10%;;">Fullbetald</div>
        </div>

        <div *ngFor="let f of mdata.fees" style="border-bottom:1px solid #F0F0F0;">
          <div class="row">
            <div style="width:5%;">{{f.year}}</div>
            <div style="width:10%;">{{f.institutionShortName}}</div>
            <div style="width:10%;">{{f.totalPaidAmount}}</div>
            <div style="width:10%;">{{f.totalAmountToPay}}</div>

            <div style="width:10%">{{f.balance}}</div>
            <div *ngIf="f.isFullyPaid" style="width:10%;">
              <i class="fa fa-check" aria-hidden="true" style="color:green;"></i>
            </div>
            <div *ngIf="!f.isFullyPaid" style="width:10%;">
              <i class="fa fa-times" aria-hidden="true" style="color:red;"></i>
            </div>

          </div>
        </div>
      </div>
</div>
    </div>
  </div>
</div>
